export function useCountdown(targetDate: string | undefined, now: Date) {
  if (!targetDate) return { days: 0, hours: 0, minutes: 0 }

  const targetMs = new Date(targetDate).getTime()
  const diff = Math.max(0, targetMs - now.getTime())
  const minutes = Math.floor(diff / 60_000) % 60
  const hours = Math.floor(diff / 3_600_000) % 24
  const days = Math.min(99, Math.floor(diff / 86_400_000))
  return { days, hours, minutes }
}
